export const CALENDLY_DEMO_MODAL_OPEN = 'Payer onboarding. Calendly. Demo modal open'
export const CALENDLY_DEMO_DATE_AND_TIME_SELECTED = 'Payer onboarding. Calendly. Demo date and time selected'
export const CALENDLY_DEMO_SCHEDULED = 'Payer onboarding. Calendly. Demo scheduled'
